<template>
  <v-flex grow>
    <v-alert
      :value="displayAlert"
      type="info"
      class="text-xs-left primary--text ma-0"
      outline
    >
      {{ text }}
    </v-alert>
  </v-flex>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'GlobalUiAlert',
  data() {
    return {
      displayAlert: false,
      text: '',
    };
  },
  methods: {
    initUiDBListener() {
      const database = firebase.database();
      const uiVersionCountRef = database.ref('ui');
      uiVersionCountRef.on('value', snapshot => {
        const data = snapshot.val();

        if (data.global_alert) {
          this.displayAlert = data.global_alert.show;
          this.text = data.global_alert.text;
        }

        this.$emit('change', this.displayAlert);
      });
    },
  },
  created() {
    this.initUiDBListener();
  },
};
</script>
